
import { Component, Vue } from "vue-property-decorator";

import {
  API_TCase,
  API_TCase_Filter,
  convertCasesForTable,
  TCase_Table,
} from "@/models/cases_expert_cases";
import { API_ROUTES } from "@/utils/API";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

const TABLE_INITIAL_LIMIT = 20;
const TABLE_INITIAL_OFFSET = 0;
const TABLE_INITIAL_ORDER = "desc";
const TABLE_INITIAL_ORDER_BY = "id";

type ParamsKeyObject = {
  [key: string]: any;
};

@Component({
  components: {
    Loader: () => import("@/components/Loader/Loader.vue"),
    ExpertServicesTable: () =>
      import("@/modules/Services/Components/Table/ExpertServicesTable.vue"),
    TableSearchbar: () => import("@/components/TableSearchbar/TableSearchbar.vue"),
  },
})
export default class Browse extends Vue {
  params: ParamsKeyObject = {
    limit: TABLE_INITIAL_LIMIT,
    offset: TABLE_INITIAL_OFFSET,
    order: TABLE_INITIAL_ORDER,
    orderBy: TABLE_INITIAL_ORDER_BY,
    search: "",
  };

  filters: API_TCase_Filter = {
    case_progress_step_name: [],
    case_type: [],
    company_name: [],
    final_decision: [],
    applicant_name: [],
    name: [],
    is_extension: [],
    has_child_case: [],
  };

  services: TCase_Table[] = [];

  init = false;
  loading = false;

  async updateQuery(payload) {
    this.params.offset = 0;

    await this.getTableServices(payload);
  }

  async getTableServices({ params, isLimit }: { params: ParamsKeyObject; isLimit: boolean }) {
    if (params.applicant_name && !params.name) delete params.applicant_name;

    if (params.name) {
      Object.assign(params, { applicant_name: params.name.replaceAll(`\u00A0`, ",") });

      delete params.name;
    }

    if (params.case_type) {
      params.case_type = params.case_type.replace(
        "СoS + Skilled Worker Outside",
        "Skilled Worker CoS"
      );

      params.case_type = params.case_type.replace(
        "СoS + Skilled Worker Inside",
        "Skilled Worker CoS Inside"
      );
    }

    if (params.is_extension) {
      params.is_extension = params.is_extension.replace("Yes", "true");

      params.is_extension = params.is_extension.replace("No", "false");
    }
    if (params.has_child_case) {
      params.has_child_case = params.has_child_case.replace("Yes", "true");

      params.has_child_case = params.has_child_case.replace("No", "false");
    }

    try {
      this.loading = true;

      // TO DO: change to API_ROUTES.CASE once testing is done
      const { data } = await this.axios.get<API_TCase[]>(API_ROUTES.CASE_EXPERT_CASES(), {
        params,
      });

      if (!data.length && !isLimit) return (this.services = []);

      const services = data.map((a) => convertCasesForTable(a));

      this.services = isLimit
        ? [...this.services, ...services]
        : data.map((a) => convertCasesForTable(a));
    } finally {
      this.loading = false;
    }
  }

  async getTableFilters() {
    try {
      const { data } = await this.axios.get<API_TCase_Filter>(API_ROUTES.CASE_EXPERT_FILTERS());

      if (!data) return;

      Object.assign(this.filters, {
        ...data,
        case_progress_step_name: data.case_progress_step_name.sort(),
        company_name: data.company_name.sort(),
        case_type: data.case_type
          .map((item) => {
            if (item === "Skilled Worker CoS") return "СoS + Skilled Worker Outside";

            if (item === "Skilled Worker CoS Inside") return "СoS + Skilled Worker Inside";

            return item;
          })
          .sort(),
        name: data.applicant_name
          .map(({ first_name, last_name }) => `${first_name}\u00A0${last_name}`)
          .sort(),
        is_extension: data.is_extension.map((item) => {
          if (item === true) return "Yes";

          if (item === false) return "No";

          return item;
        }),
        has_child_case: (data.has_child_case && data.has_child_case.length
          ? data.has_child_case
          : [true, false]
        ).map((item) => {
          if (item === true) return "Yes";

          if (item === false) return "No";

          return item;
        }),
      });

      this.filters.final_decision.push("―");
    } finally {
      this.init = true;
    }
  }

  async beforeRouteEnter(to: any, from: any, next: any) {
    next(async (vm: any) => {
      await vm.getTableServices({ params: vm.params, isLimit: true });

      await vm.getTableFilters();
    });
  }
}
